export const FormTitleDescription = ({ children }: { children: React.ReactNode }) => {
  return <p className="text-base font-normal leading-6 font-sans">{children}</p>;
};
